import { IRowSection } from './RowSections.types';

const DefaultRowSectionLazyImport: IRowSection = {
    lazyImport: () =>
        import(/* webpackChunkName: 'DefaultRowSectionComponent' */ './components/DefaultRowSection/DefaultRowSection'),
};

const PersonalizedRowSectionLazyImport: IRowSection = {
    lazyImport: () =>
        import(
            /* webpackChunkName: 'PcpRowSectionComponent' */ './components/PersonalizedRowSection/PersonalizedRowSection'
        ),
};

export const RowSectionsMapper: Record<string, IRowSection> = {
    default: DefaultRowSectionLazyImport,
    pcp_rnc_carousels: PersonalizedRowSectionLazyImport,
    pcp_buyers_carousels: PersonalizedRowSectionLazyImport,
    pcp_buyers_carousels_explore: PersonalizedRowSectionLazyImport,
    pcp_rnc_carousels_explore: PersonalizedRowSectionLazyImport,
};
